import { render, staticRenderFns } from "./AlterarOrdem.vue?vue&type=template&id=1fc9de96&scoped=true"
import script from "./AlterarOrdem.vue?vue&type=script&lang=ts"
export * from "./AlterarOrdem.vue?vue&type=script&lang=ts"
import style0 from "./AlterarOrdem.vue?vue&type=style&index=0&id=1fc9de96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc9de96",
  null
  
)

export default component.exports